// extracted by mini-css-extract-plugin
module.exports = {"chipContainer":"Chips_chipContainer__3U98K","chips":"Chips_chips__3IMIo","closeIcon":"Chips_closeIcon__2q1gR"};